
/* styles */
require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-0a602de2\",\"scoped\":false,\"hasInlineConfig\":true}!sass-loader?sourceMap!../../vue-loader/lib/selector?type=styles&index=0!./Chartjs.vue")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./Chartjs.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0a602de2\"}!../../vue-loader/lib/selector?type=template&index=0!./Chartjs.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-bulma-chartjs/src/Chartjs.vue
// module id = 194
// module chunks = 40